/* eslint-disable */
// import { firebase } from "@firebase/app";
import "@firebase/firestore";
import * as firebase from 'firebase'
// firebase init goes here
const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyDh9o4mQNtblvyDi1vFA1Oa2UjLAihbO3k',
  authDomain: 'jomapp-firebase.firebaseapp.com',
  databaseURL: 'https://jomapp-firebase.firebaseio.com',
  projectId: 'jomapp-firebase',
  storageBucket: 'jomapp-firebase.appspot.com',
  messagingSenderId: '1040929469624'
});

// firebase utils
// const db = firebase.firestore()
// const fb = firebase

// date issue fix according to firebase

// firebase collections
// const usersCollection = db.collection('users')

// export {
//   db,
//   fb
// }
export const fbStorage = firebaseApp.storage();



// WEBPACK FOOTER //
// ./src/firebaseConfig.js